import { useTranslation } from "react-i18next";
import { getOptionValue } from "common/enums";

const useCurrentLanguage = () => {
  const { i18n } = useTranslation();

  return getOptionValue("languageEnum", i18n.language);
};

export default useCurrentLanguage;
